/* import axios from "axios";
import { api_URL } from "./Constantes";



const instance = axios.create({

    baseURL: api_URL,
    headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
       
    }
});


export default instance; */
// AxiosInstance.js
import axios from 'axios';
import { api_URL } from './Constantes';

const api = axios.create({
  baseURL: api_URL, // Remplacez par votre URL de base
});

// Intercepteur pour ajouter les headers à chaque requête
api.interceptors.request.use(config => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');

  if (userId && username) {
    config.headers['user_id'] = userId;
    config.headers['username'] = username;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

export default api;


